export default "__VITE_PUBLIC_ASSET__4e157e65__"